document.addEventListener('DOMContentLoaded', () => {

	const FrontAccessToken = '9b0c65d741e551dee80c3a09542bb767';
	const storageKey = 'try_on_selection';

	if (document.getElementById('shopify-try-on-box')) {

		new Vue({
			delimiters: ['$[', ']'],
			el: '#shopify-try-on-box',
			data: {
				ready: false,
				mounted: false,
				activeTab: 'all-try-ons',
				products: null,
				cursor: null,
				hasNextPage: true,
				filters: [{
					productMetafield: {
						namespace: 'global',
						key: 'enable_try_on',
						value: 'true'
					}
				}],
				boxProducts: [],
				preparingCard: false,
				quickViewItem: null,
			},
			mounted: async function () {

				try {

					await this.queryProducts(true);
					this.mounted = true;
					this.ready = true;

					//Check if products exsit in localstorage.
					const savedSelection =  JSON.parse(window.localStorage.getItem(storageKey))
					if(_.isObject(savedSelection)) {
						this.boxProducts = savedSelection;
					}

				} catch (error) {
					console.log(error)
				}


			},
			methods: {

				async queryProducts(reset = false){

					try {

						if(reset) {
							this.cursor = null;
							this.hasNextPage = true;
						}

						const query = `
							query Collection($handle: String, $cursor: String, $filters: [ProductFilter!]) {
								collection(handle: $handle) {
									id
									handle
									title
									products(first: 9, after: $cursor, filters: $filters) {
										pageInfo {
											endCursor
											hasNextPage
											hasPreviousPage
											startCursor
										}
										edges {
											cursor
											node {
												availableForSale
												createdAt
												description
												descriptionHtml
												handle
												id
												title
												featuredImage {
													altText
													height
													id
													originalSrc
													src
													transformedSrc
													url
													width
												}
												metafields(
													identifiers: [{namespace: "custom", key: "collection"}, {namespace: "custom", key: "setting_style"}, {namespace: "custom", key: "metal_color"}, {namespace: "custom", key: "design_number"}]
												) {
													namespace
													key
													value
												}
												variants(first: 20) {
													nodes {
														id
														sku
														title
														metafields(identifiers:[
															{namespace: "custom", key: "metal_color"}
														]) {
															namespace
															key
															value
														}
														selectedOptions {
															name
															value
														}
														image {
															url
															altText
															height
															width
														}
													}
												}
												priceRange {
													minVariantPrice {
														amount
														currencyCode
													}
													maxVariantPrice {
														amount
														currencyCode
													}
												}
											}
										}
										filters {
											id
											label
											type
											values {
												id
												input
												label
												count
											}
										}
									}
								}
							}
						`;
	
						const variables = {
							handle: this.activeTab,
							cursor: this.cursor,
							filters: this.filters
						}
	
						const result = await fetch(`https://${Shopify.shop}/api/2023-07/graphql.json`, {
							method: 'POST',
							headers: {
								'X-Shopify-Storefront-Access-Token': FrontAccessToken,
								'Content-Type': 'application/json',
							},
							body:JSON.stringify({
								query: query,
								variables: variables
							})
						}).then( response => response.json())

						if(this.activeTab === 'engagement-rings' || this.activeTab === 'wedding-bands') {
							if(_.find(this.filters, 'variantMetafield')) {
								result.data.collection.products.edges = result.data.collection.products.edges.map( edge => {
									edge.node.variants.nodes = edge.node.variants.nodes.filter( variant => !_.isEmpty(variant.metafields.filter( meta => meta && meta.value === _.find(this.filters,'variantMetafield').variantMetafield.value ))  ) 
									return edge;
								})
							}
	
							if(_.find(this.filters, 'variantOption')) {
								result.data.collection.products.edges = result.data.collection.products.edges.map( edge => {
									edge.node.variants.nodes = edge.node.variants.nodes.filter( variant => !_.isEmpty(variant.selectedOptions.filter( option => option && option.value === _.find(this.filters,'variantOption').variantOption.value ))  ) 
									return edge;
								})
							}
						}

						if(this.activeTab === 'mens-bands') {
							if(_.find(this.filters, 'variantMetafield')) {
								result.data.collection.products.edges = result.data.collection.products.edges.map( edge => {
									edge.node.variants.nodes = edge.node.variants.nodes.filter( variant => !_.isEmpty(variant.metafields.filter( meta => meta && meta.value === _.find(this.filters,'variantMetafield').variantMetafield.value ))  ) 
									return edge;
								})
							}
						}


						if(reset) {
							this.products = result?.data?.collection?.products;
							this.cursor = result?.data?.collection?.products?.pageInfo?.endCursor;
							return;
						}

						this.products.edges = [...this.products.edges, ...result?.data?.collection?.products?.edges];
						this.cursor = result?.data?.collection?.products?.pageInfo?.endCursor;
						this.hasNextPage = result?.data?.collection?.products?.pageInfo?.hasNextPage;
						return;


					} catch (error) {
						console.log(error);
						return false;
					}


				},
				openQuickView($event, product) {
					$event.preventDefault();
					this.quickViewItem = product;
					console.log(product)
				},
				closeQuickView() {
					this.quickViewItem = null;
				},
				handleFilterChange($event) {

					try {

						const dataTarget = JSON.parse($event.target.getAttribute('data-target'));
						const removeFilter = (dataTarget) => {
							this.filters = this.filters.map( t =>  {

								if(typeof t.productMetafield !== 'undefined' && dataTarget.filter === 'productMetafield' && dataTarget.key === t.productMetafield.key) return false;
								if(typeof t.variantMetafield !== 'undefined' && dataTarget.filter === 'variantMetafield' && dataTarget.key === t.variantMetafield.key) return false;
								if(typeof t.variantOption !== 'undefined' && dataTarget.filter === 'variantOption' && dataTarget.name === t.variantOption.name) return false;
								return t;

							}).filter( t => t !== false );
						}

						removeFilter(dataTarget); //Remove filter just in case a duplicate accrues.


						//if the value is empty try to find it in the filter object and remove it.
						if(!$event.target.value) return this.queryProducts(true);

						//Get the filter parameters from the data object.
						let filterParams = null;
						this.products.filters.forEach( filter => filter.values.forEach( value => {
							if(value.id === $event.target.value) filterParams = JSON.parse(value.input);
						}) )

						this.filters = [...this.filters, filterParams];
						this.queryProducts(true);

					} catch( error ) {
						console.log(error)
					}
				},

				handleMinPriceChange($event) {
					let value = Math.max(0, parseFloat($event.target.value));
					if(!this.filters.price) this.filters.price = {}
					this.filters.price.min = value;
					console.log(this.filters)
					this.queryProducts(true);
				},

				handleMaxPriceChange($event) {
					let value = Math.max(0, parseFloat($event.target.value));
					if(!this.filters.price) this.filters.price = {}
					this.filters.price.max = value;
					this.queryProducts(true);
				},

				async loadMore() {
					this.queryProducts();
				},

				switchTab($tab) {
					this.activeTab = $tab
					this.filters = [{
						productMetafield: {
						namespace: 'global',
						key: 'enable_try_on',
						value: 'true'
						}
					}];
					this.cursor = null;
					this.queryProducts(true);
				},

				handleAddToBox(product) {
					delete product.cursor;
					product.node.variants.nodes = [product.node.variants.nodes[0]]

					// return product.node.variants.nodes = product.node.variants.nodes[0]
					if(this.boxProducts.length < 3) {
						//if the product already exist then escape
						if(this.boxProducts.filter( boxProduct => boxProduct.node.variants.nodes[0].id === product.node.variants.nodes[0].id).length > 0) return;

						this.boxProducts = [...this.boxProducts, product];
						console.log(this.boxProducts)

						//Save selection localstorage.
						this.handleSavingSelection();
					}
				},

				handleSavingSelection() {
					window.localStorage.setItem(storageKey, JSON.stringify(this.boxProducts));
				},

				removeBoxProducts(product) {
					this.boxProducts = this.boxProducts.filter( boxProduct => boxProduct.node.variants.nodes[0].id !== product.node.variants.nodes[0].id);
					this.handleSavingSelection();
				},

				removeAllBoxProducts() {
					this.boxProducts = [];
					this.handleSavingSelection();
				},

				checkoutList() {

					if(this.preparingCard) return;

					const variants = this.boxProducts.map( item => {
						return item.node.variants.nodes[0].id
					})

					const propertiesTitles = this.boxProducts.map(item => {
						return `${item.node.metafields.filter( metafield => !_.isNull(metafield) && metafield.key === 'design_number')[0].value}`
					})

					this.preparingCard = true;

					fetch(`https://partners.fancylab.com/kirk-kara/api/create-tryonbox`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify({
							variants,
						})
					}).then( response => response.json())
					.then( response => {
						if(!response.status) {
							this.preparingCard = false;
							return window.alert('Something went wrong please try again later.')
						}

						const id = response?.result?.data?.productCreate?.product?.variants?.edges[0].node.legacyResourceId;
						console.log(id)

						fetch('/cart/add.js', {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json'
							},
							body: JSON.stringify({
								items: [{
									id: id,
									quantity: 1,
									properties: {
										'Ring 1': propertiesTitles[0],
										'Ring 2': propertiesTitles[1],
										'Ring 3': propertiesTitles[2],
									},
								}]
							})
						}).then( response => response.json())
						.then( response => {
							this.removeAllBoxProducts()
							return window.location.replace('/cart');
						}).catch( error => {
							this.preparingCard = false;
							return window.alert('Something went wrong please try again later.');
						})


					}).catch( error => {
						console.log(error);
						this.preparingCard = false;
					})

				}
			}
		});

	}//End checking if the element exist.



}, false);